import React, {useState, useEffect} from 'react';
import axios from "axios";

import {TextInput, Icon, Button} from '@gravity-ui/uikit';
import {File, Magnifier} from "@gravity-ui/icons";

import {
    ALL_TRAVEL_GRANTS_ENDPOINT,
    getAcceptAuthConfig,
    EXPORT_TRAVEL_GRANTS_ENDPOINT
} from "../../../api/api";
import TravelGrantsTable from "../../../components/TravelGrantsTable/TravelGrantsTable";
import LoadingSpinner from "../../../components/LoadingSpinner";

const filterGrants = (searchText, allData) => {
    if (!searchText) {
        return allData;
    }
    return allData.filter(({user, livings, comment, motivation}) =>
        user.last_name.toLowerCase().includes(searchText.toLowerCase()) ||
        user.first_name.toLowerCase().includes(searchText.toLowerCase()) ||
        user.email.toLowerCase().includes(searchText.toLowerCase()) ||
        user.address.toLowerCase().includes(searchText.toLowerCase()) ||
        user.phone_number.toLowerCase().includes(searchText.toLowerCase()) ||
        user.contact.toLowerCase().includes(searchText.toLowerCase()) ||
        (livings && livings.some(living =>
            living.local_workshop.venue.name.toLowerCase().includes(searchText.toLowerCase())
        )) ||
        (comment && comment.toLowerCase().includes(searchText.toLowerCase())) ||
        (motivation && motivation.toLowerCase().includes(searchText.toLowerCase()))
    );
}

function TravelGrantsList() {
    const [isLoading, setIsLoading] = useState(true);
    const [downloadLoading, setDownloadLoading] = useState(false);

    const [allGrants, setAllGrants] = useState([]);
    const [enteredValue, setEnteredValue] = useState("");
    const [filteredGrants, setFilteredGrants] = useState(allGrants);

    useEffect(() => {
        axios
            .get(ALL_TRAVEL_GRANTS_ENDPOINT, getAcceptAuthConfig())
            .then(response => {
                setAllGrants(response.data);
                setFilteredGrants(response.data);
            })
            .catch(error => {
                console.error('There was an error fetching the travel grants:', error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    useEffect(() => {
        const Debounce = setTimeout(() => {
            setFilteredGrants(filterGrants(enteredValue, allGrants));
        }, 300);

        return () => clearTimeout(Debounce);
    }, [enteredValue, allGrants]);

    const handleDownloadTravelGrants = async () => {
        setDownloadLoading(true);
        try {
            const response = await axios({
                url: EXPORT_TRAVEL_GRANTS_ENDPOINT,
                method: 'GET',
                responseType: 'blob',
                headers: getAcceptAuthConfig().headers,
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            const contentDisposition = response.headers['content-disposition'];
            let fileName = 'travel_grants_export.xlsx';

            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                if (fileNameMatch && fileNameMatch.length === 2) {
                    fileName = fileNameMatch[1];
                }
            }

            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Download error:', error);

            if (error.response && error.response.status === 404) {
                alert('Нет данных для выгрузки');
            } else if (error.response && error.response.status === 403) {
                alert('У вас нет прав для выгрузки данных');
            } else {
                alert('Ошибка при выгрузке файла');
            }
        } finally {
            setDownloadLoading(false);
        }
    };

    return (
    <>
        <h3 className="mb-2">Тревел гранты</h3>
        <hr className="clearfix w-100 pb-0"/>

        <TextInput className={"search-input mt-3 mb-2"}
                   size="l"
                   placeholder="Search..."
                   leftContent={<Icon data={Magnifier}/>}
                   hasClear={true}
                   value={enteredValue}
                   onChange={(e) => setEnteredValue(e.target.value)}
        />

        <div className="d-flex align-items-center justify-content-between mb-3">
            <div className="d-flex gap-2">
                <Button view="normal" size="m"
                        onClick={handleDownloadTravelGrants}
                        loading={downloadLoading}
                        disabled={downloadLoading}>
                    <Icon data={File} size={18}/>
                    {downloadLoading ? 'Загрузка...' : 'Скачать Excel со всеми грантами'}
                </Button>
            </div>
            <div className="grants__quantity-info quantity-info">
                Количество тревел грантов: {filteredGrants.length}
            </div>
        </div>

        {isLoading &&
            <LoadingSpinner/> ||
            <TravelGrantsTable grants={filteredGrants} setGrants={setFilteredGrants} setAllGrants={setAllGrants}
                               allGrants={allGrants}/>}
    </>
    );
}

export default TravelGrantsList;